import supabaseClient from '@/api/supabaseClient.ts';
import { FunctionsHttpError, SupabaseClient } from '@supabase/supabase-js';
import { useMutation } from '@tanstack/react-query';
import { EditReservationRequest } from '@/types/request/EditReservationRequest';
import { queryClient } from '@/main.tsx';

const useReservationEdit = () => {
  const client = supabaseClient;

  const mutationFn = async (request: EditReservationRequest) => {
    return cancelReservation(client, request);
  };

  return useMutation({
    mutationFn,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['reservations'] });
    },
  });
};

export default useReservationEdit;

async function cancelReservation(client: SupabaseClient, request: EditReservationRequest): Promise<void> {
  const { error } = await client.functions.invoke('edit-reservation', {
    body: { ...request },
  });

  if (error && error instanceof FunctionsHttpError) {
    const errorMessage = await error.context.json();

    if (errorMessage.message) {
      throw new Error(errorMessage.message);
    }

    if (errorMessage.error) {
      throw new Error(errorMessage.error);
    }

    throw new Error(error.message);
  }

  if (error) throw new Error('Failed to edit reservation. Try again later.');

  return;
}
